import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
/**
 * Favorites utility - normalize backend app favorites and prepare save payloads.
 */
export function normalizeFavorites(retVal = {}) {
  const apps = Array.isArray(retVal.apps) ? retVal.apps.filter(Boolean) : [];
  const ids = apps.map(app => app.id).filter(Boolean);
  return {
    // 收藏数量以后端返回为准；异常时回退到可用应用数量，避免显示 undefined。
    favoriteCount: typeof retVal.favoriteCount === "number" ? retVal.favoriteCount : ids.length,
    apps,
    ids
  };
}

/**
 * Toggle one favorite id while preserving the original favorite order.
 */
export function toggleFavorite(id, favorites = []) {
  const favs = Array.isArray(favorites) ? favorites.slice() : [];
  const idx = favs.indexOf(id);
  if (idx >= 0) {
    favs.splice(idx, 1);
  } else if (id) {
    favs.push(id);
  }
  return favs;
}

/**
 * Keep only currently visible app ids before sending the complete favorite list.
 */
export function getVisibleFavoriteIds(favorites = [], visibleApps = []) {
  const visibleIds = new Set((Array.isArray(visibleApps) ? visibleApps : []).map(app => app && app.id).filter(Boolean));
  return (Array.isArray(favorites) ? favorites : []).filter(id => visibleIds.has(id));
}